const host = "https://prodbackend.aalgoo.in/api"
//const host = "https://preprodbackend.aalgoo.in/api"
//const host = "http://localhost:9002/api"
export const HOST = host
export const Login = host + "/login";
export const GET_OTP = host + '/send_otp';
export const VERIFY_OTP = host + '/verify_otp';
export const GETDASHBOARD_METRICS = host + '/dashboard/metrics';
export const GET_PROFITABLE_STRATEGIES = host + '/metrics/strategies';
export const GET_STRATEGIES_ME = host + '/strategies';
export const GET_MARKETPLACE = host + '/marketplace';
export const GET_PENDING = host + '/dashboard/pending';
export const GET_PROFILE = host + '/profile';
export const GET_PNL_CHART = host + '/dashboard/pnlboard';
export const CLIENT_ID = "978661041017-nap5dp0cmdrfpn9mvstlv3olm4es649l.apps.googleusercontent.com"
//export const WebSocketUrl = "wss://preprodbackend.aalgoo.in"
export const WebSocketUrl = "wss://prodbackend.aalgoo.in"